<p-checkbox
  [binary]="true"
  [inputId]="inputId()"
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [indeterminate]="indeterminate()"
  (onChange)="handleChange($event)">
</p-checkbox>
